import { Button } from "@mui/material";
import { apiProductsList } from "api/productApi";
import PlusIcon from "assets/icons/PlusIcon";
import Table from "components/Table2";
import Number from "components/Table2/CellComps/Number";
import Price from "components/Table2/CellComps/Price";
import Select from "components/Table2/CellComps/Select";
import Text from "components/Table2/CellComps/Text";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import shortid from "shortid";
import { STContext } from ".";
import MultiSelect, { MultiSelectRow } from "components/Factor2/comps/MultiSelect";
// @ts-ignore
import BarcodeReader from "react-barcode-reader";
import axios from "../../../axios/axios";

interface Row {
    ind?: string;
    productId?: number;
    title?: string;
    barcode?: string;
    unit?: string;
    quantity?: number;
    price?: number;
    countFirst?: number;
    countSecond?: number;
    countThird?: number;
    countFinal?: number;
}

export interface ProductsTableProps {
    onChange?: (rows: Row[]) => void;
    mainData?: { warehouseId: number }
}

export default function ProductsTable({ onChange, mainData }: ProductsTableProps) {
    const dispatch: any = useDispatch();
    const { token } = useSelector((state: any) => state).businessReducer.business;
    const { products }: ProductReducer = useSelector((state: any) => state).productReducer;
    const [rows, setRows] = useState<Row[]>([]);
    const [count, setCount] = useState(0);
    const [pagination, setPagination] = useState({ page: 1, perPage: 5 });

    const data = useContext(STContext);

    useEffect(() => dispatch(apiProductsList({ token })), [token]);
    useEffect(() => onChange && onChange(rows.filter((x) => x.productId)), [rows]);
    useEffect(() => initRows(), []);

    useEffect(() => {
        const items = data?.WarehouseHandling_Items;
        if (!items) return;
        const nr: Row[] = items.map((x: any) => {
            return {
                ind: shortid.generate(),
                productId: x.ProductId,
                barcode: x.Product?.barcode,
                unit: x.unit,
                quantity: x.quantity ? x.quantity : 0,
                price: x.price,
                countFirst: x.countFirst ? x.countFirst : 0,
                countSecond: x.countSecond ? x.countSecond : 0,
                countThird: x.countThird ? x.countThird : 0,
                countFinal: x.countFinal ? x.countFinal : 0,
            };
        });
        setRows(nr);
        reRender();
    }, [data]);

    function initRows() {
        if (rows.length === 0) {
            const arr = [];
            for (let i = 0; i < 5; i++) {
                arr.push({
                    ind: shortid.generate(),
                    productId: 0,
                    title: "",
                    barcode: "",
                    unit: "",
                    quantity: 0,
                    price: 0,
                    countFirst: 0,
                    countSecond: 0,
                    countThird: 0,
                    countFinal: 0,

                });
            }
            setRows(arr);
        }
    }

    function handleChange(item: StringObj, options?: any) {
        let newRows = [...rows];
        let ind = options && options.row && options.row.ind;
        const index = newRows.findIndex((x) => x.ind === ind);
        if (index >= 0) newRows[index] = { ...newRows[index], ...item };
        setRows(newRows);
        reRender();
    }

    function handleAddRow() {
        return new Promise<{ ind: string; rows: Row[] }>((resolve) => {
            const ind = shortid.generate();
            const newRows = [...rows, {
                ind,
                productId: 0,
                title: "",
                barcode: "",
                unit: "",
                quantity: 0,
                price: 0,
                countFirst: 0,
                countSecond: 0,
                countThird: 0,
                countFinal: 0,
            }];
            setRows(newRows);
            reRender();
            resolve({ ind, rows: newRows });
        });
    }

    function handleDelete(row: any) {
        let ind = row && row.ind;
        let newRows = [...rows];
        newRows = newRows.filter((x) => x.ind !== ind);
        setRows(newRows);
        reRender();
    }

    const reRender = () => setCount((count) => count + 1);

    async function handleMultiSelect(Rows?: MultiSelectRow[]) {
        if (!Rows) return;
        let newRows = [...rows];
        for (let Row of Rows) {
            let row = newRows.find((x) => !x.productId);
            if (!row) {
                const addRowRes = await handleAddRow();
                row = { ind: addRowRes.ind };
                newRows.push(row);
            }
            const index = newRows.findIndex((x) => x.ind === row?.ind);
            if (index < 0) return;
            const product = Row.product;

            row = {
                ...row,
                productId: product.id,
                barcode: product.barcode,
                price: product.sellPrice,
                unit: Row.unit,
                quantity: product.productCount || 1,
            };
            newRows[index] = row;
        }
        setRows(newRows);
    }

    async function handleBarcodeScan(barcode: number) {
        const product = products.find((x) => x.barcodes.includes(`${barcode}`));
        let newRows = [...rows];
        let row = newRows.find((x) => !x.productId);
        if (!row) {
            const addRowRes = await handleAddRow();
            row = { ind: addRowRes.ind };
            newRows.push(row);
        }
        const index = newRows.findIndex((x) => x.ind === row?.ind);
        if (index < 0) return;
        if (product) {
            row = {
                ...row,
                productId: product.id,
                barcode: product.barcode,
                price: product.sellPrice,
                unit: product.unit,
                quantity: product.productCount || 1,
            };
            newRows[index] = row;
            setRows(newRows);
        }
    }

    return (
        <div style={{ backgroundColor: "#ffffff", borderRadius: 6, marginBottom: 24 }}>
            <BarcodeReader
                onError={(err: any, a: any, b: any) => console.log(err, a, b)}
                onScan={(barcode: any) => {
                    handleBarcodeScan(barcode);
                }}
            />
            <div
                id="header"
                style={{
                    padding: "12px 24px",
                    borderBottom: "1px solid #F6F7FA",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <span style={{ fontSize: 16 }}>کالا</span>
                {/* <Button
          variant="outlined"
          style={{ color: "#7D96B8", borderColor: "#7D96B8", gap: 10, alignItems: "center" }}
        >
          <span>
            <ExcelIcon color="#7D96B8" style={{ fontSize: 20 }} />
          </span>
          <span>اکسل</span>
        </Button> */}
            </div>
            <div style={{ padding: "24px" }}>
                <div style={{ position: "relative", overflow: "auto", whiteSpace: "nowrap" }}>
                    <Table
                        headers={[
                            { label: "کالا", style: { minWidth: 200 } },
                            { label: "بارکد", style: { minWidth: 100 } },
                            { label: "واحد", style: { minWidth: 70 } },
                            { label: "آخرین موجودی", style: { minWidth: 100 } },
                            { label: "مبلغ واحد", style: { minWidth: 150 } },
                            { label: "شمارش ۱", style: { minWidth: 100 } },
                            { label: "شمارش ۲", style: { minWidth: 100 } },
                            { label: "شمارش ۳", style: { minWidth: 100 } },
                            { label: "موجودی نهایی", style: { minWidth: 100 } },
                        ]}
                        cols={[
                            {
                                Comp: Select,
                                key: "productId",
                                data: { options: products },
                                options: {
                                    inputProps: {
                                        withClear: true,
                                        menuStyle: { minWidth: 420 },
                                        btnTextStyle: { fontSize: 12 },
                                        withRefresh: true,
                                        refreshList: () => {
                                            dispatch(apiProductsList({ token }));
                                        },
                                    },
                                    onClear: (row: any) => {
                                        handleChange({ ind: row.ind }, { row });
                                    },
                                    onChange: async (val: any, { row }: any) => {
                                        let count = val?.productCount || 0;
                                        let warehouseId = mainData?.warehouseId
                                        let productId = val.id

                                        if (warehouseId && productId) {
                                            try {
                                                const url = `warehouses/${warehouseId}/${productId}`;
                                                const conf = { headers: { Authorization: `Bearer ${token}` } };
                                                count = (await axios.post(url, {}, conf)).data.quantity;
                                            } catch (error) { }
                                        }

                                        let newRow: Row = {
                                            ind: row.ind,
                                            productId: val.id,
                                            barcode: val.barcode,
                                            price: val.sellPrice,
                                            unit: val.unit,
                                            quantity: count,
                                        };
                                        handleChange(newRow, { row });
                                    },
                                },
                            },
                            { Comp: Text, key: "barcode" },
                            { Comp: Text, key: "unit" },
                            { Comp: Number, key: "quantity", options: { editable: true } },
                            { Comp: Price, key: "price", options: { editable: true } },
                            { Comp: Number, key: "countFirst", options: { editable: true } },
                            { Comp: Number, key: "countSecond", options: { editable: true } },
                            { Comp: Number, key: "countThird", options: { editable: true } },
                            { Comp: Number, key: "countFinal", options: { editable: true } },
                        ]}
                        rows={rows}
                        headerColor="#fff"
                        onChange={handleChange}
                        onDelete={handleDelete}
                        // paginationAction={<MultiSelect onChange={handleMultiSelect} />}
                        pagination={{
                            ...pagination,
                            onChange: ({ page, perPage }) => setPagination((x) => ({ ...x, page, perPage })),
                        }}
                    />
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0px 24px 24px",
                }}
            >
                <Button style={{ gap: "10px" }} onClick={handleAddRow}>
                    <PlusIcon scale={0.6} />
                    <span>افزودن ردیف</span>
                </Button>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 20 }}>
                    <span>تعداد:</span>
                    <span>{rows.filter((x) => x.productId).length} عدد</span>
                </div>
            </div>
        </div>
    );
}
